import React from 'react';
import './FeaturedPressCard.scss';
import Arrow from '../../../Icons/Arrow';
import { COLORS } from '../../../../../constants/colors';

/**
 * Renders content for a featured press card type
 * @param {object} logo - the logo url and alt
 * @param {string} title - the card title/quote
 * @param {string} link - the link for the card
 * @returns {JSX.Element}
 * @constructor
 */
const FeaturedPressCard = ({ logo, title, link }) => {
  return (
    <div className="c-featured-press-card">
      <div className="c-card__logo">
        <img src={logo.url} alt={logo.alt} />
      </div>
      <div className="c-featured-press-card__title h3-roobert color-black">
        <h3>{title}</h3>
      </div>
      <div className="c-featured-press-card__cta eyebrow-1">
        <a href={link}>
          <span>Read Article</span>
          <Arrow color={COLORS.blue} />
        </a>
      </div>
    </div>
  );
};

export default FeaturedPressCard;
